export default {"src":"/_next/static/media/vant.f5460ef5.svg","height":35,"width":73,"blurWidth":0,"blurHeight":0};